export default __webpack_public_path__ + "static/media/punks-macro-background.ab5ba659.png";